export const automotiveBrands = {
  // Marcas Alemãs
  volkswagen: {
    name: 'Volkswagen',
    logo: 'https://cdn.simpleicons.org/volkswagen',
    category: 'cars',
    type: 'automaker',
  },
  bmw: {
    name: 'BMW',
    logo: 'https://cdn.simpleicons.org/bmw',
    category: 'cars',
    type: 'automaker',
  },
  mercedes: {
    name: 'Mercedes-Benz',
    logo: 'https://cdn.simpleicons.org/mercedes',
    category: 'cars',
    type: 'automaker',
  },
  audi: {
    name: 'Audi',
    logo: 'https://cdn.simpleicons.org/audi',
    category: 'cars',
    type: 'automaker',
  },
  porsche: {
    name: 'Porsche',
    logo: 'https://cdn.simpleicons.org/porsche',
    category: 'cars',
    type: 'automaker',
  },
  opel: {
    name: 'Opel',
    logo: 'https://cdn.simpleicons.org/opel',
    category: 'cars',
    type: 'automaker',
  },
  skoda: {
    name: 'Skoda',
    logo: 'https://cdn.simpleicons.org/skoda',
    category: 'cars',
    type: 'automaker',
  },

  // Marcas Japonesas
  mitsubishi: {
    name: 'Mitsubishi',
    logo: 'https://cdn.simpleicons.org/mitsubishi',
    category: 'cars',
    type: 'automaker',
  },
  toyota: {
    name: 'Toyota',
    logo: 'https://cdn.simpleicons.org/toyota',
    category: 'cars',
    type: 'automaker',
  },
  honda: {
    name: 'Honda',
    logo: 'https://cdn.simpleicons.org/honda',
    category: 'cars',
    type: 'automaker',
  },
  nissan: {
    name: 'Nissan',
    logo: 'https://cdn.simpleicons.org/nissan',
    category: 'cars',
    type: 'automaker',
  },
  mazda: {
    name: 'Mazda',
    logo: 'https://cdn.simpleicons.org/mazda',
    category: 'cars',
    type: 'automaker',
  },
  lexus: {
    name: 'Lexus',
    logo: 'https://cdn.simpleicons.org/lexus',
    category: 'cars',
    type: 'luxury',
  },
  subaru: {
    name: 'Subaru',
    logo: 'https://cdn.simpleicons.org/subaru',
    category: 'cars',
    type: 'automaker',
  },
  suzuki: {
    name: 'Suzuki',
    logo: 'https://cdn.simpleicons.org/suzuki',
    category: 'cars',
    type: 'automaker',
  },
  infiniti: {
    name: 'Infiniti',
    logo: 'https://cdn.simpleicons.org/infiniti',
    category: 'cars',
    type: 'luxury',
  },
  isuzu: {
    name: 'Isuzu',
    logo: 'https://cdn.simpleicons.org/isuzu',
    category: 'cars',
    type: 'automaker',
  },
  yamaha: {
    name: 'Yamaha',
    logo: 'https://cdn.simpleicons.org/yamaha',
    category: 'motorcycles',
    type: 'automaker',
  },
  kawasaki: {
    name: 'Kawasaki',
    logo: 'https://cdn.simpleicons.org/kawasaki',
    category: 'motorcycles',
    type: 'automaker',
  },

  // Marcas Americanas
  ford: {
    name: 'Ford',
    logo: 'https://cdn.simpleicons.org/ford',
    category: 'cars',
    type: 'automaker',
  },
  chevrolet: {
    name: 'Chevrolet',
    logo: 'https://cdn.simpleicons.org/chevrolet',
    category: 'cars',
    type: 'automaker',
  },
  dodge: {
    name: 'Dodge',
    logo: 'https://cdn.simpleicons.org/dodge',
    category: 'cars',
    type: 'automaker',
  },
  chrysler: {
    name: 'Chrysler',
    logo: 'https://cdn.simpleicons.org/chrysler',
    category: 'cars',
    type: 'automaker',
  },
  jeep: {
    name: 'Jeep',
    logo: 'https://cdn.simpleicons.org/jeep',
    category: 'cars',
    type: 'automaker',
  },
  ram: {
    name: 'RAM',
    logo: 'https://cdn.simpleicons.org/ram',
    category: 'trucks',
    type: 'automaker',
  },
  gmc: {
    name: 'GMC',
    logo: 'https://cdn.simpleicons.org/gmc',
    category: 'trucks',
    type: 'automaker',
  },
  tesla: {
    name: 'Tesla',
    logo: 'https://cdn.simpleicons.org/tesla',
    category: 'cars',
    type: 'automaker',
  },
  cadillac: {
    name: 'Cadillac',
    logo: 'https://cdn.simpleicons.org/cadillac',
    category: 'cars',
    type: 'luxury',
  },
  pontiac: {
    name: 'Pontiac',
    logo: 'https://cdn.simpleicons.org/pontiac',
    category: 'cars',
    type: 'automaker',
  },

  // Marcas Italianas
  fiat: {
    name: 'Fiat',
    logo: 'https://cdn.simpleicons.org/fiat',
    category: 'cars',
    type: 'automaker',
  },
  alfa_romeo: {
    name: 'Alfa Romeo',
    logo: 'https://cdn.simpleicons.org/alfaromeo',
    category: 'cars',
    type: 'automaker',
  },
  abarth: {
    name: 'Abarth',
    logo: 'https://cdn.simpleicons.org/abarth',
    category: 'cars',
    type: 'performance',
  },
  ferrari: {
    name: 'Ferrari',
    logo: 'https://cdn.simpleicons.org/ferrari',
    category: 'cars',
    type: 'luxury',
  },
  lamborghini: {
    name: 'Lamborghini',
    logo: 'https://cdn.simpleicons.org/lamborghini',
    category: 'cars',
    type: 'luxury',
  },
  maserati: {
    name: 'Maserati',
    logo: 'https://cdn.simpleicons.org/maserati',
    category: 'cars',
    type: 'luxury',
  },
  lancia: {
    name: 'Lancia',
    logo: 'https://cdn.simpleicons.org/lancia',
    category: 'cars',
    type: 'automaker',
  },
  ducati: {
    name: 'Ducati',
    logo: 'https://cdn.simpleicons.org/ducati',
    category: 'motorcycles',
    type: 'automaker',
  },

  // Marcas Francesas
  renault: {
    name: 'Renault',
    logo: 'https://cdn.simpleicons.org/renault',
    category: 'cars',
    type: 'automaker',
  },
  peugeot: {
    name: 'Peugeot',
    logo: 'https://cdn.simpleicons.org/peugeot',
    category: 'cars',
    type: 'automaker',
  },
  citroen: {
    name: 'Citroën',
    logo: 'https://cdn.simpleicons.org/citroen',
    category: 'cars',
    type: 'automaker',
  },
  bugatti: {
    name: 'Bugatti',
    logo: 'https://cdn.simpleicons.org/bugatti',
    category: 'cars',
    type: 'luxury',
  },
  dacia: {
    name: 'Dacia',
    logo: 'https://cdn.simpleicons.org/dacia',
    category: 'cars',
    type: 'automaker',
  },

  // Marcas Coreanas
  hyundai: {
    name: 'Hyundai',
    logo: 'https://cdn.simpleicons.org/hyundai',
    category: 'cars',
    type: 'automaker',
  },
  kia: {
    name: 'Kia',
    logo: 'https://cdn.simpleicons.org/kia',
    category: 'cars',
    type: 'automaker',
  },

  // Marcas Inglesas
  mini: {
    name: 'MINI',
    logo: 'https://cdn.simpleicons.org/mini',
    category: 'cars',
    type: 'automaker',
  },
  land_rover: {
    name: 'Land Rover',
    logo: 'https://cdn.simpleicons.org/landrover',
    category: 'cars',
    type: 'automaker',
  },
  jaguar: {
    name: 'Jaguar',
    logo: 'https://cdn.simpleicons.org/jaguar',
    category: 'cars',
    type: 'automaker',
  },
  bentley: {
    name: 'Bentley',
    logo: 'https://cdn.simpleicons.org/bentley',
    category: 'cars',
    type: 'luxury',
  },
  triumph: {
    name: 'Triumph',
    logo: 'https://cdn.simpleicons.org/triumph',
    category: 'motorcycles',
    type: 'automaker',
  },

  // Marcas Suecas
  volvo: {
    name: 'Volvo',
    logo: 'https://cdn.simpleicons.org/volvo',
    category: 'cars',
    type: 'automaker',
  },

  // Marcas Chinesas
  chery: {
    name: 'Chery',
    logo: 'https://cdn.simpleicons.org/chery',
    category: 'cars',
    type: 'automaker',
  },
  byd: {
    name: 'BYD',
    logo: 'https://cdn.simpleicons.org/byd',
    category: 'cars',
    type: 'automaker',
  },

  // Marcas Espanholas
  cupra: {
    name: 'Cupra',
    logo: 'https://cdn.simpleicons.org/cupra',
    category: 'cars',
    type: 'performance',
  },

  // Marcas Veículos pesados
  man: {
    name: 'Man',
    logo: 'https://cdn.simpleicons.org/man',
    category: 'trucks',
    type: 'automaker',
  },

  scania: {
    name: 'Scania',
    logo: 'https://cdn.simpleicons.org/scania',
    category: 'trucks',
    type: 'automaker',
  },
}

export const getBrandLogo = brandName => {
  const normalizedName = brandName
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9]/g, '')
  return automotiveBrands[normalizedName]?.logo || null
}
